import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { isInstalled } from "./helpers/device";
import { outputP3ColorFromRGB } from "./helpers/colors";
import pJson from "../package.json";
import { useTranslation } from "react-i18next";

const FancyFooter = styled.footer`
  padding: 1em;
  text-align: center;
  color: var(--softText);

  a:hover {
    color: var(--text);
  }
`;

const Warning = styled.span`
  ${outputP3ColorFromRGB([255, 255, 0])}
`;

const Copyright = styled.div`
  margin-top: 0.6em;
  font-size: 0.78em;
  line-height: 1.5;
  opacity: 0.55;
`;

export default function Footer() {
  const { t } = useTranslation();
  const location = useLocation();

  if (location.pathname !== "/" && isInstalled()) return null;

  return (
    <FancyFooter>
      v{pJson.version} — <Link to="/terms">{t("Terms & Privacy")}</Link> —{" "}
      <Warning>⚠️ {t("Fly Warning")}</Warning>
      <Copyright>
        Copyright © 2021 Alexander Harding —{" "}
        {t("Original MIT licence of ppg.report.")}
        <br />
        Copyright © 2026 Patrick Tremblay —{" "}
        {t(
          "All rights reserved for the current version (improvements and new features).",
        )}
      </Copyright>
    </FancyFooter>
  );
}
